import { defineStore } from 'pinia'
import type { AxiosError } from 'axios'
import axios from 'axios'
import type { RequestState } from '~/base/types/appTypes'
import 'pinia'

export interface AppStore {
  requestState: RequestState
  isOnline: boolean
  environment: string
}

export const useAppStore = defineStore('app', {
  state: (): AppStore => {
    return {
      requestState: {
        loading: false,
        failed: false,
        error: null
      },
      isOnline: navigator.onLine,
      environment:
        window.location.hostname.match('termine-dev') ||
        window.location.hostname.match('localhost')
          ? 'dev'
          : window.location.hostname.match('termine-stage')
            ? 'stage'
            : 'live'
    }
  },
  getters: {},
  actions: {
    updateOnlineState(isOnline: boolean) {
      this.isOnline = isOnline
    },

    requestStarted(): void {
      this.setRequestState({
        loading: true,
        failed: false
      })
    },

    requestFailed(e: unknown): void {
      console.log(e)
      const error = this.isApiError(e) ? e : null
      this.setRequestState({
        loading: false,
        failed: true,
        error
      })
    },

    requestSucceeded(): void {
      this.setRequestState({
        loading: false,
        failed: false,
        error: null
      })
    },

    isApiError(error: unknown): error is AxiosError {
      return axios.isAxiosError(error)
    },

    setRequestState(requestState: Partial<RequestState>): void {
      this.requestState = {
        ...this.requestState,
        ...requestState
      }
    }
  }
})
